import { AppHeader, DemoNotice } from '../components/common';
import { useT } from '../hooks/useT';
import { useBank } from '../state/BankContext';
import { useSettings } from '../state/SettingsContext';

export function HelpScreen() {
  const t = useT();
  const { uiLang } = useSettings();
  const { questions, signs } = useBank();

  return (
    <>
      <AppHeader title={t('keyboardHelp')} />
      <main id="main" className="app-main stack">
        <section className="card stack-sm">
          <h2 className="card__title">{t('keyboardHelp')}</h2>
          <ul style={{ margin: 0, paddingInlineStart: '1.2rem' }}>
            <li>{t('keyAnswer')}</li>
            <li>{t('keyRead')}</li>
            <li>{t('keyPause')}</li>
            <li>{t('keyStop')}</li>
            <li>{t('keyNext')}</li>
          </ul>
        </section>

        <section className="card stack-sm">
          <h2 className="card__title">{t('appName')}</h2>
          <p style={{ margin: 0 }}>
            {uiLang === 'ar'
              ? `يحتوي التطبيق حالياً على ${questions.length} سؤالاً و${signs.length} إشارة طريق.`
              : `The app currently holds ${questions.length} questions and ${signs.length} road signs.`}
          </p>
          <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '0.9rem' }}>
            {uiLang === 'ar'
              ? 'لإضافة أسئلة جديدة، افتح ملف README.md في مجلد المشروع، أو استخدم صفحة إدارة الأسئلة.'
              : 'To add more questions, open README.md in the project folder, or use the Question Manager page.'}
          </p>
        </section>

        <DemoNotice />

        <section className="card stack-sm">
          <h2 className="card__title">{t('dataAndPrivacy')}</h2>
          <p style={{ margin: 0 }}>{t('privacyNote')}</p>
        </section>
      </main>
    </>
  );
}
